import React, { useState, useEffect } from 'react';
import Logo from './logo.png';
import BrandImg from './authentication.png';

const Login = ({ handleLogin }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth <= 1024;

  return (
    <div style={styles.page}>
      <div style={{
        ...styles.card,
        width: isMobile ? '90%' : isTablet ? '90%' : '1000px',
        height: isMobile ? 'auto' : '650px',
        flexDirection: isMobile ? 'column' : 'row',
        margin: '20px auto'
      }}>
        {/* LEFT COLUMN: BRAND IMAGE (Hidden on mobile if desired, or shown on top) */}
        {!isMobile && (
          <div style={styles.leftCol}>
            <img src={BrandImg} alt="Brand" style={styles.brandImage} />
          </div>
        )}

        {/* RIGHT COLUMN: LOGIN FORM */}
        <div style={{
          ...styles.rightCol,
          padding: isMobile ? '60px 20px' : '40px',
          minHeight: isMobile ? '400px' : 'auto'
        }}>
          <div style={styles.formContainer}>
            <img src={Logo} alt="NexBook Logo" style={{
              ...styles.logo,
              width: isMobile ? '140px' : '180px',
              marginBottom: isMobile ? '24px' : '32px'
            }} />
            <h1 style={{
              ...styles.title,
              fontSize: isMobile ? '24px' : '28px'
            }}>Log in to NexBook</h1>
            <p style={styles.subtitle}>Sign in to manage your data</p>
            
            <button onClick={handleLogin} style={styles.googleButton}>
              <svg width="20" height="20" viewBox="0 0 24 24" style={{ marginRight: '12px' }}>
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.18 1-.78 1.85-1.63 2.42v2.01h2.64c1.55-1.42 2.43-3.52 2.43-5.94z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 12-4.53z"
                />
              </svg>
              Sign in with Google
            </button>
          </div>
          
          <footer style={{
            ...styles.footer,
            position: isMobile ? 'static' : 'absolute',
            marginTop: isMobile ? '40px' : '0'
          }}>
            © {new Date().getFullYear()} NexRise India.
          </footer>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f3f4f6',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  card: {
    display: 'flex',
    width: '1000px',
    height: '650px',
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    overflow: 'hidden',
  },
  leftCol: {
    flex: 1,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  brandImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  rightCol: {
    flex: 1.2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    position: 'relative',
    backgroundColor: '#1b1b1d',
  },
  formContainer: {
    width: '100%',
    maxWidth: '360px',
    textAlign: 'center',
  },
  logo: {
    width: '180px',
    height: 'auto',
    marginBottom: '32px',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: 'white',
    marginBottom: '8px',
  },
  subtitle: {
    fontSize: '16px',
    color: '#9ca3af',
    marginBottom: '40px',
  },
  googleButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: '600',
    color: '#374151',
    backgroundColor: 'white',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  footer: {
    position: 'absolute',
    bottom: '24px',
    color: '#6b7280',
    fontSize: '13px',
  },
};

export default Login;
